module.exports = __webpack_public_path__ + "img/processing-01.ccf9d8aa.gif";